export const translations = {
  en: {
    formulaEditor: "Formula Plotter",
    formulaEditorDescription: "Create and edit mathematical graphs",
    editor: "Editor",
    examples: "Examples",
    newFormula: "New Formula",
    formulaType: "Formula Type",
    functionYofX: "Function y = f(x)",
    parametricXYofT: "Parametric x(t), y(t)",
    polarRofTheta: "Polar r = f(θ)",
    color: "Color",
    strokeWidth: "Line Width",
    samples: "Data Points",
    functionExpression: "Enter function f(x)",
    parametricExpression: "Enter parametric equations",
    polarExpression: "Enter polar expression",
    functionExpressionHint: "Use JavaScript syntax: x*x, Math.sin(x), etc.",
    parametricExpressionHint: "Format: x(t); y(t) - use semicolon between expressions",
    polarExpressionHint: "Use 'theta' as the angle variable",
    xRange: "X Range",
    tRange: "T Range",
    thetaRange: "θ Range",
    deleteFormula: "Delete",
    use: "Use",
    categories: {
      basic: "Basic Functions",
      trigonometric: "Trigonometric",
      exponential: "Exponential",
      parametric: "Parametric Curves",
      special: "Special Curves",
      polynomial: "Polynomial Functions"
    },
    formulaPlotter: "Formula Plotter",
    openFormulaTool: "Open Formula Plotter",
    closeFormulaTool: "Close Formula Plotter",
    tooltips: {
      select: "Select and move",
      moveDescription: "Click to select, drag to move; use Delete to remove",
      rotate: "Rotate",
      rotateDescription: "Rotate the selected shape",
      plot: "Plot formula",
      plotDescription: "Create mathematical graphs on the grid"
    },
    scaleFactor: "Scale Factor",
    scaleFactorHint: "Adjust to make the graph flatter or steeper",
    scaleMin: "0.001x",
    scaleDefault: "1.0x",
    scaleMax: "10.0x",
    formulaPlaceholder: "x*x",
    formulaDefault: "f(x)",
    exampleCategory: "Category",
    exampleName: "Name",
    exampleDescription: "Description",
    colorPicker: "Pick a color",
    deleteFormulaTooltip: "Delete this formula",
    browseExamples: "Browse examples",
    pointX: "X Coordinate",
    pointY: "Y Coordinate",
    calculation: "Calculation",
    calculationError: "Error calculating value",
    coordinateLabel: "Coordinate",
    parametricPointInfo: "Parametric function (t value not available)",
    polarPointInfo: "Polar function (θ value not available)",
    pointInfoTitle: "Point Information",
    clickOnCurveInstruction: "Click on the curve to select a point and view its information.",
    pointInfo: {
      navigation: 'Navigation',
      stepLabel: 'Step',
      navigatePoints: 'Navigate points',
      adjustStep: 'Adjust step size',
      holdShiftForOne: 'Hold Shift to temporarily use 1.0 step size',
      leftArrow: 'Left Arrow',
      rightArrow: 'Right Arrow'
    },
    gridZoom: 'Grid Zoom',
    gridZoomHint: 'Adjust the zoom level of the grid',
    zoomIn: 'Zoom In',
    zoomOut: 'Zoom Out',
    zoomLevel: 'Zoom Level',
    zoomReset: 'Reset Zoom',
    toast: {
      loadedShapes: 'Loaded {count} shapes from URL',
      loadedFormulas: 'Loaded {count} formulas from URL',
      shapeCreated: '{type} created!',
      shapeDeleted: 'Shape deleted',
      clearedShapesKeepPlots: 'All shapes cleared, plots preserved',
      invalidPositiveNumber: 'Please enter a valid positive number',
      urlCopied: 'URL copied to clipboard! Share it to restore this canvas.',
      urlCopyFailed: 'Failed to copy URL to clipboard'
    },
    gridHint: {
      moveOrigin: 'Alt+Click to move grid origin',
      moveAll: 'Alt+Shift+Click to move grid and shapes'
    },
    gridZoomTooltips: {
      zoomOut: 'Zoom Out (Ctrl -)',
      zoomReset: 'Click to Reset Zoom to 100%',
      zoomIn: 'Zoom In (Ctrl +)'
    }
  },
  es: {
    formulaEditor: "Trazador de Fórmulas",
    formulaEditorDescription: "Crea y edita gráficos matemáticos",
    editor: "Editor",
    examples: "Ejemplos",
    newFormula: "Nueva Fórmula",
    formulaType: "Tipo de Fórmula",
    functionYofX: "Función y = f(x)",
    parametricXYofT: "Paramétrica x(t), y(t)",
    polarRofTheta: "Polar r = f(θ)",
    color: "Color",
    strokeWidth: "Grosor de Línea",
    samples: "Puntos de Datos",
    functionExpression: "Introduzca función f(x)",
    parametricExpression: "Introduzca ecuaciones paramétricas",
    polarExpression: "Introduzca expresión polar",
    functionExpressionHint: "Use sintaxis JavaScript: x*x, Math.sin(x), etc.",
    parametricExpressionHint: "Formato: x(t); y(t) - use punto y coma entre expresiones",
    polarExpressionHint: "Use 'theta' como variable de ángulo",
    xRange: "Rango X",
    tRange: "Rango T",
    thetaRange: "Rango θ",
    deleteFormula: "Eliminar",
    use: "Usar",
    categories: {
      basic: "Funciones Básicas",
      trigonometric: "Trigonométricas",
      exponential: "Exponenciales",
      parametric: "Curvas Paramétricas",
      special: "Curvas Especiales",
      polynomial: "Funciones Polinómicas"
    },
    formulaPlotter: "Trazador de Fórmulas",
    openFormulaTool: "Abrir Trazador de Fórmulas",
    closeFormulaTool: "Cerrar Trazador de Fórmulas",
    tooltips: {
      select: "Seleccionar y mover",
      moveDescription: "Haz clic para seleccionar, arrastra para mover; usa Supr para eliminar",
      rotate: "Rotar",
      rotateDescription: "Gira la forma seleccionada",
      plot: "Graficar fórmula",
      plotDescription: "Crear gráficos matemáticos en la cuadrícula"
    },
    scaleFactor: "Factor de Escala",
    scaleFactorHint: "Ajuste para hacer el gráfico más plano o más pronunciado",
    scaleMin: "0.001x",
    scaleDefault: "1.0x",
    scaleMax: "10.0x",
    formulaPlaceholder: "x*x",
    formulaDefault: "f(x)",
    exampleCategory: "Categoría",
    exampleName: "Nombre",
    exampleDescription: "Descripción",
    colorPicker: "Elegir un color",
    deleteFormulaTooltip: "Eliminar esta fórmula",
    browseExamples: "Explorar ejemplos",
    pointX: "X",
    pointY: "Y",
    calculation: "Cálculo",
    calculationError: "Error al calcular el valor",
    coordinateLabel: "Coordenada",
    parametricPointInfo: "Función paramétrica (valor t no disponible)",
    polarPointInfo: "Función polar (valor θ no disponible)",
    pointInfoTitle: "Información del Punto",
    clickOnCurveInstruction: "Haz clic en la curva para seleccionar un punto y ver su información.",
    pointInfo: {
      navigation: 'Navegación',
      stepLabel: 'Paso',
      navigatePoints: 'Navegar puntos',
      adjustStep: 'Ajustar tamaño de paso',
      holdShiftForOne: 'Mantén Shift para usar temporalmente un paso de 1.0',
      leftArrow: 'Flecha izquierda',
      rightArrow: 'Flecha derecha'
    },
    gridZoom: 'Zoom del Gird',
    gridZoomHint: 'Ajustar el nivel de zoom del grid',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    zoomLevel: 'Nivel de Zoom',
    zoomReset: 'Resetear Zoom',
    toast: {
      loadedShapes: 'Se cargaron {count} formas desde la URL',
      loadedFormulas: 'Se cargaron {count} fórmulas desde la URL',
      shapeCreated: '¡{type} creada!',
      shapeDeleted: 'Forma eliminada',
      clearedShapesKeepPlots: 'Todas las formas eliminadas, gráficos conservados',
      invalidPositiveNumber: 'Por favor ingrese un número positivo válido',
      urlCopied: '¡URL copiada al portapapeles! Compártela para restaurar este lienzo.',
      urlCopyFailed: 'No se pudo copiar la URL al portapapeles'
    },
    gridHint: {
      moveOrigin: 'Alt+Click para mover el origen de la cuadrícula',
      moveAll: 'Alt+Shift+Click para mover cuadrícula y formas'
    },
    gridZoomTooltips: {
      zoomOut: 'Alejar (Ctrl -)',
      zoomReset: 'Clic para restablecer zoom a 100%',
      zoomIn: 'Acercar (Ctrl +)'
    }
  },
  fr: {
    formulaEditor: "Traceur de Formules",
    formulaEditorDescription: "Créer et éditer des graphiques mathématiques",
    editor: "Éditeur",
    examples: "Exemples",
    newFormula: "Nouvelle Formule",
    formulaType: "Type de Formule",
    functionYofX: "Fonction y = f(x)",
    parametricXYofT: "Paramétrique x(t), y(t)",
    polarRofTheta: "Polaire r = f(θ)",
    color: "Couleur",
    strokeWidth: "Épaisseur de Ligne",
    samples: "Points de Données",
    functionExpression: "Entrez fonction f(x)",
    parametricExpression: "Entrez équations paramétriques",
    polarExpression: "Entrez expression polaire",
    functionExpressionHint: "Utilisez syntaxe JavaScript: x*x, Math.sin(x), etc.",
    parametricExpressionHint: "Format: x(t); y(t) - utilisez point-virgule entre expressions",
    polarExpressionHint: "Utilisez 'theta' comme variable angulaire",
    xRange: "Plage X",
    tRange: "Plage T",
    thetaRange: "Plage θ",
    deleteFormula: "Supprimer",
    use: "Utiliser",
    categories: {
      basic: "Fonctions Basiques",
      trigonometric: "Trigonométriques",
      exponential: "Exponentielles",
      parametric: "Courbes Paramétriques",
      special: "Courbes Spéciales",
      polynomial: "Fonctions Polynomiales"
    },
    formulaPlotter: "Traceur de Formules",
    openFormulaTool: "Ouvrir le Traceur de Formules",
    closeFormulaTool: "Fermer le Traceur de Formules",
    tooltips: {
      select: "Sélectionner et déplacer",
      moveDescription: "Cliquez pour sélectionner, glissez pour déplacer ; Suppr pour supprimer",
      rotate: "Pivoter",
      rotateDescription: "Faire pivoter la forme sélectionnée",
      plot: "Tracer formule",
      plotDescription: "Créer des graphiques mathématiques sur la grille"
    },
    scaleFactor: "Facteur d'Échelle",
    scaleFactorHint: "Ajustez pour rendre le graphique plus plat ou plus raide",
    scaleMin: "0.001x",
    scaleDefault: "1.0x",
    scaleMax: "10.0x",
    formulaPlaceholder: "x*x",
    formulaDefault: "f(x)",
    exampleCategory: "Catégorie",
    exampleName: "Nom",
    exampleDescription: "Description",
    colorPicker: "Choisir une couleur",
    deleteFormulaTooltip: "Supprimer cette formule",
    browseExamples: "Parcourir les exemples",
    pointX: "X",
    pointY: "Y",
    calculation: "Calcul",
    calculationError: "Erreur de calcul de la valeur",
    coordinateLabel: "Coordonnée",
    parametricPointInfo: "Fonction paramétrique (valeur t non disponible)",
    polarPointInfo: "Fonction polaire (valeur θ non disponible)",
    pointInfoTitle: "Information du Point",
    clickOnCurveInstruction: "Cliquez sur la courbe pour sélectionner un point et afficher ses informations.",
    pointInfo: {
      navigation: 'Navigation',
      stepLabel: 'Pas',
      navigatePoints: 'Naviguer entre les points',
      adjustStep: 'Ajuster la taille du pas',
      holdShiftForOne: 'Maintenez Maj pour utiliser temporairement un pas de 1.0',
      leftArrow: 'Flèche gauche',
      rightArrow: 'Flèche droite'
    },
    naturalLanguageProcessing: "Traitement en cours...",
    naturalLanguageDescription: "Utilisez un langage naturel ou du pseudocode pour décrire la fonction que vous souhaitez créer. OpenAI la convertira en une expression mathématique.",
    configModal: {
      title: "Configuration",
      description: "Paramètres globaux de l'application",
      tabs: {
        general: "Général",
        openai: "OpenAI",
        developer: "Développeur"
      },
      general: {
        description: "Paramètres généraux de l'application",
        languageLabel: "Langue",
        languagePlaceholder: "Sélectionnez une langue"
      },
      openai: {
        description: "Paramètres de l'API OpenAI",
        apiKeyLabel: "Clé API",
        apiKeyPlaceholder: "Entrez votre clé API OpenAI",
        apiKeyHint: "Votre clé API est stockée localement et chiffrée",
        clearApiKey: "Effacer la clé API"
      },
      developer: {
        description: "Options de développement",
        loggingLabel: "Niveau de journalisation",
        loggingDescription: "Définir le niveau de détail des journaux"
      },
      calibration: {
        title: "Calibration",
        description: "Calibrez l'écran pour des mesures précises",
        instructions: "Pour calibrer, mesurez une distance connue sur votre écran",
        lengthLabel: "Longueur de référence",
        startButton: "Commencer la calibration",
        placeRuler: "Placez une règle sur votre écran",
        lineDescription: "Ajustez la ligne pour qu'elle mesure exactement {length} {unit}",
        coarseAdjustment: "Ajustement grossier",
        fineAdjustment: "Ajustement fin",
        currentValue: "Valeur actuelle",
        pixelsPerUnit: "pixels/{unit}",
        cancelButton: "Annuler",
        applyButton: "Appliquer"
      }
    },
    gridZoom: 'Zoom du Gird',
    gridZoomHint: 'Ajuster le niveau de zoom du grid',
    zoomIn: 'Acercar',
    zoomOut: 'Alejar',
    zoomLevel: 'Niveau de Zoom',
    zoomReset: 'Resetear Zoom',
    toast: {
      loadedShapes: '{count} formes chargées depuis l’URL',
      loadedFormulas: '{count} formules chargées depuis l’URL',
      shapeCreated: '{type} créée !',
      shapeDeleted: 'Forme supprimée',
      clearedShapesKeepPlots: 'Toutes les formes supprimées, tracés conservés',
      invalidPositiveNumber: 'Veuillez entrer un nombre positif valide',
      urlCopied: 'URL copiée ! Partagez-la pour restaurer ce canevas.',
      urlCopyFailed: 'Échec de la copie de l’URL'
    },
    gridHint: {
      moveOrigin: 'Alt+Clic pour déplacer l’origine de la grille',
      moveAll: 'Alt+Maj+Clic pour déplacer la grille et les formes'
    },
    gridZoomTooltips: {
      zoomOut: 'Dézoomer (Ctrl -)',
      zoomReset: 'Cliquer pour réinitialiser le zoom à 100 %',
      zoomIn: 'Zoomer (Ctrl +)'
    }
  },
  de: {
    formulaEditor: "Formelplotter",
    formulaEditorDescription: "Erstellen und bearbeiten Sie mathematische Graphen",
    editor: "Editor",
    examples: "Beispiele",
    newFormula: "Neue Formel",
    formulaType: "Formeltyp",
    functionYofX: "Funktion y = f(x)",
    parametricXYofT: "Parametrisch x(t), y(t)",
    polarRofTheta: "Polar r = f(θ)",
    color: "Farbe",
    strokeWidth: "Linienbreite",
    samples: "Datenpunkte",
    functionExpression: "Funktion f(x) eingeben",
    parametricExpression: "Parametrische Gleichungen eingeben",
    polarExpression: "Polarausdruck eingeben",
    functionExpressionHint: "Verwenden Sie JavaScript-Syntax: x*x, Math.sin(x), usw.",
    parametricExpressionHint: "Format: x(t); y(t) - Verwenden Sie Semikolon zwischen Ausdrücken",
    polarExpressionHint: "Verwenden Sie 'theta' als Winkelvariable",
    xRange: "X-Bereich",
    tRange: "T-Bereich",
    thetaRange: "θ-Bereich",
    deleteFormula: "Löschen",
    use: "Verwenden",
    categories: {
      basic: "Grundfunktionen",
      trigonometric: "Trigonometrische",
      exponential: "Exponentielle",
      parametric: "Parametrische Kurven",
      special: "Spezielle Kurven",
      polynomial: "Polynomfunktionen"
    },
    formulaPlotter: "Formelplotter",
    openFormulaTool: "Formelplotter öffnen",
    closeFormulaTool: "Formelplotter schließen",
    tooltips: {
      select: "Auswählen und bewegen",
      moveDescription: "Klicken zum Auswählen, ziehen zum Bewegen; Entfernen löscht",
      rotate: "Drehen",
      rotateDescription: "Ausgewählte Form drehen",
      plot: "Formel plotten",
      plotDescription: "Erstellen Sie mathematische Graphen auf dem Raster"
    },
    scaleFactor: "Skalierungsfaktor",
    scaleFactorHint: "Anpassen, um den Graphen flacher oder steiler zu machen",
    scaleMin: "0.001x",
    scaleDefault: "1.0x",
    scaleMax: "10.0x",
    formulaPlaceholder: "x*x",
    formulaDefault: "f(x)",
    exampleCategory: "Kategorie",
    exampleName: "Name",
    exampleDescription: "Beschreibung",
    colorPicker: "Farbe auswählen",
    deleteFormulaTooltip: "Diese Formel löschen",
    browseExamples: "Beispiele durchsuchen",
    pointX: "X",
    pointY: "Y",
    calculation: "Berechnung",
    calculationError: "Fehler bei der Berechnung des Wertes",
    coordinateLabel: "Koordinate",
    parametricPointInfo: "Parametrische Funktion (t-Wert nicht verfügbar)",
    polarPointInfo: "Polarfunktion (θ-Wert nicht verfügbar)",
    pointInfoTitle: "Punktinformation",
    clickOnCurveInstruction: "Klicken Sie auf die Kurve, um einen Punkt auszuwählen und seine Informationen anzuzeigen.",
    pointInfo: {
      navigation: 'Navigation',
      stepLabel: 'Schritt',
      navigatePoints: 'Punkte navigieren',
      adjustStep: 'Schrittweite anpassen',
      holdShiftForOne: 'Shift halten, um temporär Schrittweite 1.0 zu nutzen',
      leftArrow: 'Pfeil links',
      rightArrow: 'Pfeil rechts'
    },
    gridZoom: 'Gitter-Zoom',
    gridZoomHint: 'Passen Sie die Zoomstufe des Gitters an',
    zoomIn: 'Vergrößern',
    zoomOut: 'Verkleinern',
    zoomLevel: 'Zoomstufe',
    zoomReset: 'Zoom zurücksetzen',
    toast: {
      loadedShapes: '{count} Formen aus der URL geladen',
      loadedFormulas: '{count} Formeln aus der URL geladen',
      shapeCreated: '{type} erstellt!',
      shapeDeleted: 'Form wurde gelöscht',
      clearedShapesKeepPlots: 'Alle Formen gelöscht, Diagramme beibehalten',
      invalidPositiveNumber: 'Bitte eine gültige positive Zahl eingeben',
      urlCopied: 'URL in die Zwischenablage kopiert! Teile sie, um diese Ansicht wiederherzustellen.',
      urlCopyFailed: 'URL konnte nicht in die Zwischenablage kopiert werden'
    },
    gridHint: {
      moveOrigin: 'Alt+Klick, um den Gitterursprung zu verschieben',
      moveAll: 'Alt+Umschalt+Klick, um Gitter und Formen zu verschieben'
    },
    gridZoomTooltips: {
      zoomOut: 'Herauszoomen (Strg -)',
      zoomReset: 'Klicken, um auf 100% zurückzusetzen',
      zoomIn: 'Hineinzoomen (Strg +)'
    }
  }
};
